import React, { Component } from 'react';
import _validator from 'modules/validator';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService';
import { Row, Col } from 'antd';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import _notification from 'modules/notification';
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import _utils from '../../modules/Utils';
import { PROJECT_LOGO } from '../../constants/constants';
import _branding from 'modules/branding';
// Phase C.5 (Candidate System UI Language Migration) migrated the page chrome OUTSIDE the printable
// receipt payload. Phase R6.6 (Candidate Receipt PDF Filename & Language Configuration Fix) migrated
// the printable payload itself (#outerBorder/#divReceiptPrint below) too — see modules/i18n/pages/
// receiptDetails.js for why it was previously left untouched and why that is no longer correct.
import Text from 'components/Text/Text';

class CandidateReceiptDetails_new extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: [],
            posts: [],
            loading: true,
            studentPersonalModel: {},
            challanBankDetailModel: {},
            studentReservationModel: {},
            isLoading: false
        };
    }


    componentDidMount() {
        this.getStudentPersonalData();
    }

    getStudentPersonalData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let response = await _StudentService.getStudentReceiptData();
                    //console.log("Receipt Data:  ", response.data);
                    this.setState({
                        data: response.data,
                        // applicationId : response.data.Application_Id,
                        studentPersonalModel: response.data.studentPersonalModel,
                        challanBankDetailModel: response.data.challanBankDetailModel,
                        studentReservationModel: response.data.studentReservationModel,
                        otherInformationModel: response.data.otherInformationModel,
                        loading: false
                    });

                } catch (e) {
                    // TODO 
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onPrint = () => {
        this.setState({ isLoading: true });
        const originalDiv = document.querySelector("#divReceiptPrint");

        // Clone the div to avoid modifying the original
        const clonedDiv = originalDiv.cloneNode(true);
        clonedDiv.style.position = "absolute";
        clonedDiv.style.left = "-9999px";
        clonedDiv.style.width = "841.89px";
        document.body.appendChild(clonedDiv);


        html2canvas(clonedDiv, {
            scale: 3, allowTaint: true, useCORS: true
        }).then(canvas => {
            const imgData = canvas.toDataURL('image/jpeg', 0.8);

            const doc = new jsPDF({
                orientation: 'p',
                unit: 'pt',
                format: 'a4',
                compressPdf: true
            });

            const pageWidth = 595.28;
            const pageHeight = 841.89;

            const margin = 1; // Margin for all sides
            const contentWidth = pageWidth - margin * 2;
            const contentHeight = pageHeight - margin * 2;

            const widthRatio = contentWidth / canvas.width;
            const heightRatio = contentHeight / canvas.height;
            const ratio = Math.min(widthRatio, heightRatio);

            const canvasWidth = canvas.width * ratio;
            const canvasHeight = canvas.height * ratio;

            // Center the image within the margins
            const xOffset = margin + (contentWidth - canvasWidth) / 2;
            const yOffset = margin;

            doc.addImage(imgData, 'JPEG', xOffset, yOffset, canvasWidth, canvasHeight);
            doc.save(this.buildReceiptFileName());
            document.body.removeChild(clonedDiv);
            this.setState({ isLoading: false });
        });



        // html2canvas(document.querySelector("#divReceiptPrint"), {
        //     scale: 3,
        //     allowTaint: true,
        //     useCORS: true
        // }).then(canvas => {
        //     const imgData = canvas.toDataURL('image/jpeg', 0.8);

        //     const doc = new jsPDF({
        //         orientation: 'p',
        //         unit: 'pt',
        //         format: 'a4',
        //         compressPdf: true
        //     });

        //     const pageWidth = doc.internal.pageSize.getWidth();
        //     const pageHeight = doc.internal.pageSize.getHeight();

        //     const margin = 1; // Define margin from all sides (20pt)
        //     const usableWidth = pageWidth - margin * 2;
        //     const usableHeight = pageHeight - margin * 2;

        //     const widthRatio = usableWidth / canvas.width;
        //     const heightRatio = usableHeight / canvas.height;
        //     const ratio = widthRatio < heightRatio ? widthRatio : heightRatio;

        //     const canvasWidth = canvas.width * ratio;
        //     const canvasHeight = canvas.height * ratio;

        //     const xOffset = (pageWidth - canvasWidth) / 2; // Center the image horizontally
        //     const yOffset = margin; // Start from the top margin

        //     doc.addImage(imgData, 'JPEG', xOffset, yOffset, canvasWidth, canvasHeight);
        //     doc.save("Candidate_Receipt.pdf");
        //     this.setState({ isLoading: false });
        // });
    }


    // Phase R6.6 (§1): the generic "Candidate_Receipt.pdf" gave every candidate's downloaded receipt the
    // exact same filename. Built from the same already-fetched data (no new API call) — mirrors
    // PreviewCandidateDetails_new.jsx's buildReceiptFileName() (Phase R6.5), the established pattern for
    // this exact problem, applied here to the Candidate Receipt instead of the Application Receipt.
    buildReceiptFileName = () => {
        const sanitize = (value) => String(value || '').trim().replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
        const model = this.state.data.studentPersonalModel || {};
        const applicationId = sanitize(model.Application_Id) || sanitize(model.Form_Number) || 'Unknown';
        const candidateName = sanitize([model.First_Name, model.Middle_Name, model.Last_Name].filter(Boolean).join('_')) || 'Candidate';
        return 'Candidate_Receipt_' + applicationId + '_' + candidateName + '.pdf';
    }

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    onTabOrderChange = () => {
        this.props.onTabOrderChange(7);
    }

    //const StudentPersonalInfo = () => {
    render() {
        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <>
                {/* <NavigationTab onTabOrderChange={this.onTabOrderChange} /> */}

                <div className="cd-priview printPage  priview-receipt gl-bxbr  analysisWrap p-4 mt-4 ch-container ">
                    <h4 className="ch-heading4 mb-4"><Text k="receiptDetails.pageHeading" /></h4>
                    <div className="cd-priview-wrap">
                        <div className="candidateform-cover pt-3 pr-3 pl-3 pb-2">
                            <div id="outerBorder" style={{ textAlign: 'center', border: 'solid', borderColor: 'gray', overflowX: 'auto' }}>
                                <div id="divReceiptPrint" style={{ textAlign: 'center', border: 'solid', borderColor: 'transparent', padding: 7, width: '1015px' }}>


                                    <div className='w-100'>
                                        {/* Phase C.7.2 (Branding Foundation): resolved through the unified priority chain
                                            (Portal_Logo → branding LogoUrl → PROJECT_LOGO) instead of a hardcoded env-config logo. */}
                                        <img alt='PROJECT_LOGO' src={_branding.resolveLogoUrl(localStorage['Portal_Logo'], PROJECT_LOGO)} className='projectLogoSizeWidth' style={{ alignSelf: 'center', cursor: "pointer" }} />
                                    </div>

                                    <div className='receipt_generation_head w-100' >
                                        <div className='receipt_generation_head_detail'>
                                            <div style={{ textAlign: 'left' }}>
                                                <div style={{ display: 'flex', width: '100%', alignItems: 'baseline' }}>
                                                    <label className='mb0' style={{ fontSize: '14px', fontWeight: 'bolder', color: 'black' }}><Text k="receiptDetails.formNoLabel" /> : </label>
                                                    <label style={{ fontSize: '14px', color: 'black', marginLeft: '5px' }}>{this.state.data.studentPersonalModel.Form_Number}</label>
                                                </div>
                                                <div className='mt5' style={{ display: 'flex', width: '100%' }}>
                                                    <label className='mb0' style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}><Text k="receiptDetails.appliedPostLabel" /> :</label>
                                                    <label style={{ fontSize: '14px', color: 'black' }}>{this.state.data.studentPersonalModel.Applied_Post}</label>
                                                </div>
                                            </div>
                                            <div>
                                                <div style={{ display: 'flex', width: '100%', alignItems: 'baseline' }}>
                                                    <label className='mb0' style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}><Text k="receiptDetails.transactionIdLabel" /> : {this.state.data.studentPersonalModel.Challan_Transaction_Id}</label>
                                                </div>
                                                <div className='mt5' style={{ display: 'flex', width: '100%' }}>
                                                    <div style={{ display: 'flex' }}>
                                                        <label className='mb0' style={{ fontSize: '14px', fontWeight: 'bold', color: 'black', marginRight: '30px' }}><Text k="receiptDetails.feesLabel" /> : {this.state.data.studentPersonalModel.Exam_Fee}</label>
                                                        <label className='mb0' style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}><Text k="receiptDetails.gstLabel" /> : {this.state.data.studentPersonalModel.GST_Fee}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: "bold",
                                                marginTop: "5px",
                                                marginBottom: "5px",
                                                color: "black",
                                                width: "100%"
                                            }}
                                        >
                                            {this.state.data.studentPersonalModel.Applied_Post}</div>
                                    </div>


                                    <div className="receipt_generation_Table2 my-2" style={{ display: 'inline-table', width: '100%' }}>
                                        <table className='table_100_percent tableHiddenBorder'>
                                            <tbody>
                                                <tr>
                                                    <td className='table_personal_info' style={{ padding: 0, borderStyle: 'hidden' }}>
                                                        <table style={{ width: '100%' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <th><Text k="receiptDetails.fullNameLabel" /></th>

                                                                    <td>{(this.state.data.studentPersonalModel.First_Name) + ' ' +
                                                                        (this.state.data.studentPersonalModel.Middle_Name) + ' ' +
                                                                        (this.state.data.studentPersonalModel.Last_Name)}
                                                                    </td>
                                                                </tr>
                                                                <tr style={{ height: '25px' }}>
                                                                    <th><Text k="receiptDetails.fathersNameLabel" /></th>
                                                                    <td>{this.state.data.studentPersonalModel.Father_Name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th><Text k="receiptDetails.mothersNameLabel" /></th>
                                                                    <td>{this.state.data.studentPersonalModel.Mother_Name}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th><Text k="receiptDetails.aadhaarNoLabel" /></th>
                                                                    <td>{this.state.data.studentPersonalModel.Aadhaar_Number}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th><Text k="receiptDetails.addressContactInfoLabel" /></th>
                                                                    <td style={{ overflowWrap: 'anywhere' }}>
                                                                        <div>
                                                                            {this.state.data.studentPersonalModel.Address}
                                                                        </div>
                                                                        Village/City : {this.state.data.studentPersonalModel.Village}, { }
                                                                        Taluka : {this.state.data.studentPersonalModel.Taluka}, { }
                                                                        Dist : {this.state.data.studentPersonalModel.District}, { }
                                                                        Pin Code : {this.state.data.studentPersonalModel.Pin_Code}, { }
                                                                        State : {this.state.data.studentPersonalModel.State}, { }
                                                                        Mobile No. : {this.state.data.studentPersonalModel.Mobile_Number}, { }
                                                                        <br></br>Email Id : {this.state.data.studentPersonalModel.Email}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={2}>
                                                                        <label style={{ marginRight: '15rem', display: 'inline', fontSize: '14px' }}><Text k="receiptDetails.genderLabel" /> : {this.state.data.studentPersonalModel.Gender}</label>
                                                                        <label style={{ display: 'inline', fontSize: '14px' }}><Text k="receiptDetails.dateOfBirthLabel" /> :{moment(this.state.data.studentPersonalModel.Birth_Date).format('DD-MMM-YYYY')}</label><br></br>
                                                                        {/* <label style={{ marginRight: '20rem', display: 'inline', fontSize: '14px' }}>Number Of Child : {(this.state.data.studentPersonalModel.Number_Of_Children) === null ? 0 : (this.state.data.studentPersonalModel.Number_Of_Children)}</label> */}
                                                                        <label style={{ display: 'inline', fontSize: '14px' }}><Text k="receiptDetails.maritalStatusLabel" /> : {this.state.data.studentPersonalModel.Marital_Status}</label>
                                                                    </td>
                                                                </tr>
                                                                {this.state.data.studentPersonalModel.IsDrivingLicenceMandatory && <tr style={{ height: '25px' }}>
                                                                    <th>Driving Licence No.</th>
                                                                    <td>{this.state.data.studentPersonalModel.DrivingLicenceNumber}</td>
                                                                </tr>}

                                                                {/* <tr>
                                                                    <td colSpan={2}>
                                                                        <label style={{ marginRight: '3rem', display: 'inline', fontSize: '14px' }}><span>Physically Handicaped / शारीरिकदृष्ट्या अपंग : </span>{(this.state.data.studentReservationModel.Is_Handicaped) === true ? 'Yes' : 'No'}</label>
                                                                    </td>
                                                                </tr> */}
                                                                <tr>
                                                                    <td colSpan={2}>
                                                                        <label style={{ marginRight: '3rem', display: 'inline', fontSize: '14px' }}><span> <Text k="receiptDetails.disabilityCategoryNameLabel" /> : </span>{(this.state.data.studentPersonalModel.DisabilityCategoryName ? this.state.data.studentPersonalModel.DisabilityCategoryName : "N/A")}</label>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={2}>
                                                                        <label style={{ display: 'inline', fontSize: '14px' }}><span><Text k="receiptDetails.isScribeRequiredLabel" /> : </span>{(this.state.data.studentPersonalModel.IsScribeRequired) === true ? 'Yes' : 'N/A'}</label>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td colSpan={2}>
                                                                        <label style={{ display: 'inline', fontSize: '14px' }}><span><Text k="receiptDetails.existingEmployeeLabel" /> : </span>{(this.state.data.studentPersonalModel.Is_KaryalayinKamkaj) === true ? 'Yes' : 'No'}</label>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td style={{ borderStyle: 'hidden' }}>
                                                        <div>
                                                            <div className='textAlignCenter'>
                                                                <img className='receipt_details_profile_img' src={this.state.data.studentPersonalModel.Profile_Pic_Path} alt="Profile" />
                                                            </div>
                                                            <div className='textAlignCenter'>
                                                                <img className='receipt_details_signature_img' src={this.state.data.studentPersonalModel.Signature_Path} alt="Signature" />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {/* <table className='table_reservation_details'>
                                            <tbody> */}
                                        {/* <tr>
                                                    <td colSpan={4}>
                                                        <Row>
                                                            <Col span={8}>
                                                                <label style={{ display: 'inline', fontSize: '14px' }}>Category / श्रेणी: {this.state.data.studentReservationModel.Category}</label>
                                                            </Col>
                                                            <Col span={8}><label style={{ display: 'inline', fontSize: '14px' }}>Caste / जात : {this.state.data.studentReservationModel.Caste}</label></Col>
                                                            <Col span={8}><label style={{ display: 'inline', fontSize: '14px' }}> Non Creamy Layer / नॉन क्रीमी लेयर : {(this.state.data.studentReservationModel.Is_NonCreamyLayer_Available) === true ? 'Yes' : 'No'}</label></Col>
                                                        </Row>
                                                    </td>
                                                </tr> */}
                                        {/* <tr>
                                                    <th className='width_40_Percent'>Physically Handicaped / शारीरिकदृष्ट्या अपंग</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Handicaped) === true ? 'Yes' : 'No'}</td>
                                                    <th>Is Scribe Required? / लेखनिक आवश्यक आहे का?</th>
                                                    <td>{(this.state.data.studentPersonalModel.IsScribeRequired) === true ? 'Yes' : 'No'}</td>
                                                </tr> */}

                                        {/* <tr>
                                                    <th>Female / महिला आरक्षण</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Ladies) === true ? 'Yes' : 'No'}</td>
                                                    <th>Ex Serviceman / माजी सैनिक</th>
                                                    <td>{(this.state.data.studentReservationModel.Ex_Serviceman) === true ? 'Yes' : 'No'}</td>

                                                </tr>

                                                <tr>
                                                    <th>Earth Quake Affected / भुकंपग्रस्त</th>
                                                    <td>{(this.state.data.studentReservationModel.Earth_Quake_Affected) === true ? 'Yes' : 'No'}</td>
                                                    <th>Anshkalin / अंशकालीन</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Anshkalin) === true ? 'Yes' : 'No'}</td>

                                                </tr>

                                                <tr>
                                                    <th>Player / खेळाडू</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Player) === true ? 'Yes' : 'No'}</td>
                                                    <th>Project Affected / प्रकल्पग्रस्त</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Praklapgast) === true ? 'Yes' : 'No'}</td>
                                                </tr>

                                                <tr>
                                                    <th className='width_40_Percent'>Existing Employee / विद्यमान कर्मचारी</th>
                                                    <td>{(this.state.data.studentPersonalModel.Is_KaryalayinKamkaj) === true ? 'Yes' : 'No'}</td>
                                                    <th>Orphan / अनाथ</th>
                                                    <td>{(this.state.data.studentReservationModel.Is_Orphan) === true ? 'Yes' : 'No'}</td>
                                                </tr> */}

                                        {/* </tbody>
                                        </table> */}

                                        <label style={{ display: 'flex', justifyContent: 'flex-start', fontSize: '14px', fontWeight: 'bold', color: 'black', marginTop: '5px', marginBottom: '5px', marginLeft: '5px' }}><Text k="receiptDetails.qualifyingExaminationLabel" /> :</label>

                                        <table className='table_100_percent'>
                                            <tbody>
                                                <tr>
                                                    <th><Text k="receiptDetails.educationColumnHeader" /></th>
                                                    <th><Text k="receiptDetails.specialisationColumnHeader" /></th>
                                                    <th><Text k="receiptDetails.boardUniversityColumnHeader" /></th>
                                                    <th><Text k="receiptDetails.yearOfPassingColumnHeader" /></th>
                                                    <th><Text k="receiptDetails.marksPercentColumnHeader" /></th>
                                                    <th><Text k="receiptDetails.classColumnHeader" /></th>
                                                </tr>

                                                {this.state.data.studentQualificationDetailModels.map((item, index) => (

                                                    <tr data-index={index}>
                                                        <th>{item.Qualification}</th>
                                                        {/* <td>{item.Specilisation && item.Specilisation.trim() === "Other" ?
                                                            item.other_specilisation : item.University_Name && item.University_Name.trim() === "Other" ?
                                                                item.Other_Information : item.Specilisation}
                                                        </td> */}
                                                        <td>{item.Specilisation && item.Specilisation.trim() === "Other" ?
                                                            item.other_specilisation : item.Specilisation} 
                                                                
                                                        </td>
                                                        <td>{item.University_Name === "Other" || item.University_Id === null || item.University_Id === 0 ? item.Other_Information : item.University_Name}</td>
                                                        <td>{item.Passed_Year}</td>
                                                        <td>{item.Percentage_Grade}</td>
                                                        <td>{item.Class}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                        {this.state.otherInformationModel &&
                                            this.state.otherInformationModel.map((item, index) => {
                                                if (index === 0) {
                                                    return (
                                                        <React.Fragment key={index}>

                                                            <table className='table_100_percent mt10'>
                                                                <tbody>
                                                                    {console.log("item.Is_Marathi_Typing_30", item.Is_Marathi_Typing_30)}
                                                                    <tr>
                                                                        <td colSpan={6} style={{ textAlign: 'center', fontSize: "14px" }}>
                                                                            <Text k="receiptDetails.typingSkillHeading" />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th colSpan={2}><Text k="receiptDetails.marathiTyping30Label" /></th>
                                                                        <td colSpan={4}>{item.Is_Marathi_Typing_30 == true ? "Yes" : "N/A"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th colSpan={2}><Text k="receiptDetails.englishTyping40Label" /></th>
                                                                        <td colSpan={4}>{item.Is_English_Typing_40 == true ? "Yes" : "N/A"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan={6} style={{ textAlign: 'center', fontSize: "14px" }}>
                                                                            <Text k="receiptDetails.shortHandHeading" />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th colSpan={2}><Text k="receiptDetails.wpm100Label" /></th>
                                                                        <td colSpan={4}>{item.Is_100_WPM == true ? "Yes" : "N/A"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th colSpan={2}><Text k="receiptDetails.wpm120Label" /></th>
                                                                        <td colSpan={4}>{item.Is_120_WPM == true ? "Yes" : "N/A"}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </React.Fragment>
                                                    );
                                                } else {
                                                    return null;
                                                }
                                            })
                                        }

                                        <label style={{ display: 'flex', justifyContent: 'flex-start', fontSize: '14px', fontWeight: 'bold', color: 'black', marginTop: '5px', marginBottom: '5px', marginLeft: '5px' }}><Text k="receiptDetails.experienceDetailsLabel" /> :</label>

                                        <table className='table_100_percent'>
                                            <tbody>
                                                {/* <tr>
                                                    <td colSpan={2}>
                                                        Typing Details / टायपिंग तपशील
                                                    </td>
                                                    <td colSpan={2}>
                                                        Short Hand Details / लघुलेखन
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>Marathi Typing 30 / मराठी टायपिंग (वेग ३०)</th>
                                                    <td>{(this.state.otherInformationModel && this.state.otherInformationModel.Is_Marathi_Typing_30) === true ? 'Yes' : 'No'}</td>
                                                    <th>100 Words/minutes / 100 शब्द/मिनिटे</th>
                                                    <td>{(this.state.otherInformationModel && this.state.otherInformationModel.Is_100_WPM) === true ? 'Yes' : 'No'}</td>
                                                </tr>
                                                <tr>
                                                    <th>English Typing 40 / इंग्रजी टायपिंग (वेग 40)</th>
                                                    <td>{(this.state.otherInformationModel && this.state.otherInformationModel.Is_English_Typing_40) === true ? 'Yes' : 'No'}</td>
                                                    <th>120 Words/minutes / 120 शब्द/मिनिटे</th>
                                                    <td>{(this.state.otherInformationModel && this.state.otherInformationModel.Is_120_WPM) === true ? 'Yes' : 'No'}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={4}>
                                                        Experience Details / अनुभव तपशील
                                                    </td>
                                                </tr> */}

                                                <tr>
                                                    <th><Text k="receiptDetails.organizationNameColumnHeader" /></th>
                                                    <th><Text k="receiptDetails.designationColumnHeader" /></th>
                                                    <th><Text k="receiptDetails.fromDateColumnHeader" /></th>
                                                    <th><Text k="receiptDetails.toDateColumnHeader" /></th>
                                                </tr>
                                                {
                                                    this.state.otherInformationModel && this.state.otherInformationModel.map((item, index) => (<>
                                                        <tr>
                                                            <td>{item.Organisation ? item.Organisation : "N/A"}</td>
                                                            <td>{item.Designation ? item.Designation : "N/A"}</td>
                                                            <td>
                                                                {item && item.From_Date ? moment(item.From_Date).format('DD-MMM-YYYY') : "N/A"}
                                                            </td>
                                                            <td>
                                                                {item && item.To_Date ? moment(item.To_Date).format('DD-MMM-YYYY') : "N/A"}
                                                            </td>
                                                        </tr>
                                                    </>
                                                    ))
                                                }

                                            </tbody>
                                        </table>

                                        <table className='table_footer_details mt-2'>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={6}><Text k="receiptDetails.declarationText" /></td>
                                                </tr>
                                                <tr style={{ height: '65px' }}>
                                                    <td><Text k="receiptDetails.placeLabel" /> : {this.state.data.studentPersonalModel.Village} </td>
                                                    <td><Text k="receiptDetails.dateLabel" /> : {moment().format("DD/MM/YYYY")}</td>
                                                    {/* <td>Signature Of the Candidate / उमेदवाराची स्वाक्षरी: { }</td> */}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="form-action d-flex justify-content-end button-global-group btn3 ">
                                    <div className="btn2-wrap mb-0">
                                        <ButtonComponent
                                            id="btnCancel"
                                            type="button"
                                            value={<div className='displayInGrid'><Text k="challanDetails.cancelButton" /></div>}
                                            className="button-global button-border mr-4 autoHeight"
                                            onClick={this.onCancel}
                                        />
                                    </div>

                                    <ButtonComponent
                                        id="btnSubmit"
                                        type="button"
                                        value={<div className='displayInGrid'><Text k="receiptDetails.printDownloadButton" /></div>}
                                        className="button-global button-secondary autoHeight"
                                        onClick={this.onPrint}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.isLoading && <LoadingSpinner />}
                </div>
            </>
        )
    };
}

export default CandidateReceiptDetails_new;